export default "__VITE_ASSET__BKqdLfYK__"